<template>
  <div class="m-account-registration layout">
    <div class="ms-row">
      <div class="col-xs-12 text--center logo-wrap">
        <router-link class="icon-link" to="/">
          <i class="iconfont icon-logo">&#xe673;</i>
        </router-link>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="m-account-registration__column m-account-registration__form">
          <div class="c-account-registration">
            <template v-if="mode == 'connect'">
              <h1 class="c-account-registration__title heading-h3">关联账户</h1>
              <div class="c-account-registration__description">您已是Sisley会员，请关联账户，享受臻享礼遇。</div>
            </template>
            <template v-else>
              <h1 class="c-account-registration__title heading-h3">创建账户</h1>
              <div class="c-account-registration__description">通过手机号码创建账户，您将成为 Sisley 会员。</div>
            </template>
            <VForm :model="baseForm" :rule="rule" ref="baseForm">
              <div class="c-account-registration__msg">*号为必填</div>
              <FormItem prop="phone">
                <input v-model="baseForm.phone" placeholder="* 手机号码" :class="['c-input', 'c-input--fullwidth', error ? 'c-input-error' : '']" />
                <div id="register-email-feedback" v-if="error" class="error-msg">{{ errMsg }}</div>
              </FormItem>
              <FormItem prop="valid_code">
                <div style="position: relative;">
                  <input v-model="baseForm.valid_code" placeholder="* 图形验证码" :class="[capthaCheck ? 'c-input-error' : '', 'c-input', 'c-input--fullwidth']" @blur="checkCaptha()" />
                  <img class="pic-code" :src="captchaImg" @click="getCaptcha" alt />
                </div>
                <div class="error-msg" v-if="capthaCheck">{{ capthaError }}</div>
              </FormItem>
              <FormItem prop="msg_code">
                <div style="position: relative;">
                  <input v-model="baseForm.msg_code" :class="[phonecodeError ? 'c-input-error' : '', 'c-input', 'c-input--fullwidth']" placeholder="* 手机验证码" maxlength="11" @blur="checkPhoneNO" />
                  <button class="send-code" :disabled="disableSendSMS" @click="sendMsg">发送验证码{{ `${countdown ? "(" + countdown + "s)" : ""}` }}</button>
                </div>
                <div class="error-msg" v-if="phonecodeError">{{ phonecodeMsg }}</div>
              </FormItem>
              <div style="display: flex;">
                <FormItem prop="sex" style="width: 48%; margin-right: 4%; display: inline-block;">
                  <MultiSelect 
                    :class="[disableSex ? 'form-control-color' : '']"
                    v-model="baseForm.sex" :options="allowedSexes" track-by="value" label="label" :disabled="disableSex" 
                    :searchable="false" :close-on-select="true" :show-labels="false" placeholder="* 称谓" 
                  />
                </FormItem>
                <FormItem prop="name" style="width: 48%; display: inline-block;">
                  <input 
                    v-model="baseForm.name" autocomplete="off" type="text" placeholder="* 姓名" maxlength="20" :disabled="disableName"
                    :class="['c-input', nameError ? 'c-input-error' : '', 'c-input--fullwidth', disableName ? 'form-control-color' : '']" 
                  />
                  <div class="error-msg" v-if="nameError">{{ nameMsg }}</div>
                </FormItem>
              </div>
              <div style="display: flex; align-items: flex-end;">
                <FormItem label="*生日" prop="year" class="years">
                  <MultiSelect
                    :class="[disableBirth ? 'form-control-color' : '']"
                    v-model="baseForm.year" :options="allowedYears" track-by="value" label="label" :disabled="disableBirth"
                    :searchable="false" :close-on-select="true" :show-labels="false" placeholder="* 年"
                  />
                </FormItem>
                <FormItem prop="month" class="months">
                  <MultiSelect
                    :class="[disableBirth ? 'form-control-color' : '']"
                    v-model="baseForm.month" :options="allowedMonths" track-by="value" label="label" :disabled="disableBirth"
                    :searchable="false" :close-on-select="true" :show-labels="false" placeholder="* 月"
                  >
                    <span slot="noOptions">请选择年</span>
                  </MultiSelect>
                </FormItem>
                <FormItem prop="date" class="days">
                  <MultiSelect
                    :class="[disableBirth ? 'form-control-color' : '']"
                    v-model="baseForm.date" :options="allowedDates" track-by="value" label="label" :disabled="disableBirth"
                    :searchable="false" :close-on-select="true" :show-labels="false" placeholder="* 日"
                  >
                    <span slot="noOptions">请选择月</span>
                  </MultiSelect>
                </FormItem>
              </div>
              <FormItem label="*密码" prop="password" v-if="!disablePassword">
                <input
                  autocomplete="off"
                  :type="iptType"
                  v-model.trim="baseForm.password"
                  :readonly="iptType == 'text'"
                  :class="['c-input', 'c-input--fullwidth']"
                  placeholder="密码必须至少包含6个字符"
                  minlength="6"
                  maxlength="16"
                  @keyup="baseForm.password = baseForm.password.replace(/[\u4e00-\u9fa5]/gi, '')"
                  @paste.capture.prevent="returnFalse()"
                  @drop.capture.prevent="returnFalse()"
                  @contextmenu.capture.prevent="returnFalse()"
                  pattern="[^\u4e00-\u9fa5]{6,16}"
                />
                <template v-if="isMobile">
                  <button class="eye-icon__container" @touchstart="toggleIptType" @touchend="toggleIptType">
                    <i class="iconfont">&#xe608;</i>
                  </button>
                </template>
                <template v-else>
                  <button class="eye-icon__container" @mousedown="toggleIptType" @mouseup="toggleIptType">
                    <i class="iconfont">&#xe608;</i>
                  </button>
                </template>
              </FormItem>
              <FormItem style="font-size: 12px;">
                <div class="privacy-row clickable" @click="userCheck = !userCheck">
                  <i class="iconfont">{{ userCheck ? "&#xedaf;" : "&#xec58;" }}</i>
                  <span>
                    我已阅读并了解Sisley希思黎网站的
                    <router-link to="/terms" target="_blank" @click.native.stop rel="nofollow">使用条款</router-link>
                    和
                    <router-link to="/privacy" target="_blank" @click.native.stop rel="nofollow">隐私政策</router-link>，并同意接受其中所有的条款
                  </span>
                </div>
              </FormItem>
              <div class="col-xs-12 text--right">
                <input type="button" class="c-button c-button--primary" :disabled="disableSubmit" :value="mode == 'connect' ? '关联账户' : '创建账户'" @click="submit" />
              </div>
            </VForm>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="m-account-registration__column">
          <div class="ms-row">
            <div class="col-xs-12 m-account-registarion__sisley-club">
              <div class="content-asset">
                <!-- dwMarker="content" dwContentID="e97acacc9c5afe95f0e4d8091f" -->
                <div class="c-sisley-club">
                  <div class="c-sisley-club__images-container">
                    <div class="c-sisley-club__image">
                      <picture>
                        <source
                          media="(min-width: 1024px)"
                          srcset="../assets/imgs/bg/my-sisley-club/gettyimages-large.png, ../assets/imgs/bg/my-sisley-club/gettyimages-large@2x.png 2x"
                        />
                        <source
                          media="(min-width: 768px)"
                          srcset="../assets/imgs/bg/my-sisley-club/gettyimages-medium.png, ../assets/imgs/bg/my-sisley-club/gettyimages-medium@2x.png 2x"
                        />
                        <source
                          media="(min-width: 0)"
                          srcset="../assets/imgs/bg/my-sisley-club/gettyimages-small.png, ../assets/imgs/bg/my-sisley-club/gettyimages-small@2x.png 2x"
                        />
                        <img
                          class="lazyloaded"
                          srcset="../assets/imgs/bg/my-sisley-club/gettyimages-large@2x.png 2x"
                          src="../assets/imgs/bg/my-sisley-club/gettyimages-large.png"
                        />
                      </picture>
                    </div>
                    <div class="c-sisley-club__image">
                      <picture>
                        <source
                          media="(min-width: 1024px)"
                          srcset="../assets/imgs/bg/my-sisley-club/express-flower-gel-double-large.png, ../assets/imgs/bg/my-sisley-club/express-flower-gel-double-large@2x.png 2x"
                        />
                        <source
                          media="(min-width: 768px)"
                          srcset="../assets/imgs/bg/my-sisley-club/express-flower-gel-double-medium.png, ../assets/imgs/bg/my-sisley-club/express-flower-gel-double-medium@2x.png 2x"
                        />
                        <source
                          media="(min-width: 0)"
                          srcset="../assets/imgs/bg/my-sisley-club/express-flower-gel-double-small.png, ../assets/imgs/bg/my-sisley-club/express-flower-gel-double-small@2x.png 2x"
                        />
                        <img
                          class="lazyloaded"
                          srcset="../assets/imgs/bg/my-sisley-club/express-flower-gel-double-large@2x.png 2x"
                          src="../assets/imgs/bg/my-sisley-club/express-flower-gel-double-large.png"
                        />
                      </picture>
                    </div>
                    <div class="c-sisley-club__title-container horizontal-center">
                      <img
                        class="lazyloaded"
                        alt="My Sisley Club"
                        src="../assets/imgs/bg/my-sisley-club/my-sisley-club-title.svg"
                      />
                    </div>
                  </div>
                  <div
                    class="ms-row col-xs-12 center-xs float-center c-sisley-club__text heading-h4"
                  >加入Sisley法国希思黎致臻坊会员，即可享受会员臻萃奢护服务。</div>
                  <div class="ms-row col-xs-12 center-xs">
                    <ul
                      class="c-loyalty-card__description c-loyalty-card__description--list text--left"
                    >
                      <li class="c-loyalty-card__description-item">会员积分礼遇</li>
                      <li class="c-loyalty-card__description-item">悦享专属惊喜</li>
                    </ul>
                  </div>
                  <div class="ms-row">
                    <p>&nbsp;</p>
                  </div>
                  <div class="ms-row col-xs-12 center-xs c-sisley-club__button">
                    <router-link to="/member-club" class="c-button c-button--secondary">了解更多</router-link>
                  </div>
                </div>
              </div>
              <!-- End content-asset -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VForm from "@/components/form/my-form";
import FormItem from "@/components/form/form-item";
import MultiSelect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import types from "@/store/types";
import api from "@/utils/api";
import utils from "@/utils";

const regEmoji = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[A9|AE]\u3030|\uA9|\uAE|\u3030/gi;
export default {
  components: { VForm, FormItem, MultiSelect },
  data() {
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入手机号码"));
      } else if (!/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error("请输入正确的手机号码"));
      } else {
        callback();
      }
    };
    var checkPassword = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("密码不能为空"));
      } else if (value.length < 6) {
        callback(new Error("密码必须包含6个字符"));
      } else {
        callback();
      }
    };
    var checkName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("姓名不能为空"));
      } else if (regEmoji.test(value)) {
        callback(new Error("姓名中包含Emoji字符"));
      } else {
        callback();
      }
    };
    var checkCode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("图形验证码不能为空"));
      } else if (this.errMsg) {
        return callback(new Error(this.errMsg));
      } else {
        callback();
      }
    };
    return {
      mode: 'create',
      captchaImg: "",
      iptType: "password",
      baseForm: {
        valid_id: "",
        valid_code: "",
        phone: "",
        msg_code: "",
        sex: "",
        name: "",
        year: "",
        month: "",
        date: "",
        password: "",
      },
      countdown: 0,
      rule: {
        phone: [{ required: true, validator: checkPhone, trigger: "blur" }],
        valid_code: [{ validator: checkCode }],
        msg_code: [
          { required: true, message: "手机验证码不能为空", trigger: "blur" },
        ],
        sex: [{ required: true, message: "请选择称谓" }],
        name: [{ validator: checkName }],
        year: [{ required: true, message: "请选年" }],
        month: [{ required: true, message: "请选月" }],
        date: [{ required: true, message: "请选日" }],
        password: [{ validator: checkPassword }]
      },
      userCheck: true,
      error: false,
      errMsg: null,
      capthaCheck: false,
      capthaError: "",
      phonecodeError: false,
      phonecodeMsg: "",
      nameError: false,
      nameMsg: "",
      disableSex: false,
      disableName: false,
      disableBirth: false,
      disablePassword: false
    };
  },
  created() {
    // let sso_code = utils.getItem("sso_code");
    // if (!sso_code) {
    //   this.$router.back();
    //   return;
    // } else {
    //   this.ssoCode = sso_code;
    // }
    this.getCaptcha();
  },
  updated() {},
  methods: {
    returnFalse() { return false; },
    getCaptcha() {
      api[types.GET_CAPTCHA]().then((res) => {
        this.captchaImg = res.data.img;
        this.baseForm.valid_id = res.data.key;
      }).catch();
    },
    checkCaptha() {
      let { valid_id, valid_code } = this.baseForm;
      if (!valid_code) return;
      api[types.CHECK_CAPTCHA]({ valid_id, valid_code }).then((res) => {
        if (res.code == 1) {
          this.capthaCheck = false;
          this.capthaError = "";
        } else {
          this.capthaCheck = true;
          this.capthaError = res.message;
        }
      }).catch();
    },
    sendMsg() {
      api[types.SEND_MSG]({
        phone: this.baseForm.phone,
        valid_id: this.baseForm.valid_id,
        valid_code: this.baseForm.valid_code,
        type: 5,
      }).then((res) => {
        if (res.code == 1) {
          this.runCountdown(60, (time) => {
            this.countdown = time;
          });
        } else {
          switch (res.data.field) {
            case "msg_code":
              this.phonecodeError = true;
              this.phonecodeMsg = res.message;
              break;
            case "valid_code":
              this.capthaCheck = true;
              this.capthaError = res.message;
              break;
            case "name":
              this.nameError = true;
              this.nameMsg = res.message;
              break;
            default:
              this.error = true;
              this.errMsg = res.message;
              break;
          }
        }
      }).catch();
    },
    checkPhoneNO() {
      let { phone, valid_id, valid_code, msg_code } = this.baseForm;
      if (!phone || !valid_code || !msg_code) return;
      if (phone && !/^1[3456789]\d{9}$/.test(phone)) {
        this.error = true;
        this.errMsg = "手机号码格式不正确";
        return;
      }
      if (!/\d{6}/.test(msg_code)) {
        this.phonecodeError = true;
        this.phonecodeMsg = "短信验证码为6位数字";
        return;
      }
      let newArgs = {
        phone,
        valid_id,
        valid_code,
        msg_code,
        sso_code: utils.getItem('sso_code')
      };
      api[types.SOCIAL_LOGIN](newArgs).then(res => {
        let { code, data } = res;
        if (code == 1) {
          let isComplete = data.is_complete;
          if (isComplete == 0) {
            // 官网用户直接登录
            let returnUrl = decodeURIComponent(this.$route.query.returnUrl || "/");
            let isCheckout = returnUrl.indexOf("checkout") != -1;
            this.$store.commit(types.USER_LOGIN, res);
            this.$store.dispatch(types.GET_PROFILE);
            this.$store.dispatch(types.CART_GET, () => {
              isCheckout && this.$router.replace({ path: returnUrl });
            });
            this.$store.dispatch(types.FAV_PIDS_LIST);
            !isCheckout && this.$router.replace({ path: returnUrl });
          } else if (isComplete == 1) {
            this.mode = "connect";
            // CRM用户回填数据
            let { sex, name, birth, password, pos_id, sign } = data;
            this.baseForm.pos_id = pos_id;
            this.baseForm.sign = sign;
            if (sex !== "") {
              this.disableSex = true;
              this.baseForm.sex = {
                label: sex == 1 ? "先生" : "女士",
                value: sex,
              };
            }
            if (name !== "") {
              this.disableName = true;
              this.baseForm.name = name;
            }
            if (birth) {
              this.disableBirth = true;
              this.baseForm.birth = birth;
              this.baseForm.year = {
                label: `${this.baseForm.birth.split("-")[0]}年`,
                value: this.baseForm.birth.split("-")[0],
              };
              this.baseForm.month = {
                label: `${this.baseForm.birth.split("-")[1]}月`,
                value: this.baseForm.birth.split("-")[1],
              };
              this.baseForm.date = {
                label: `${this.baseForm.birth.split("-")[2]}日`,
                value: this.baseForm.birth.split("-")[2],
              };
            }
            if (password !== "") this.disablePassword = true;
          } else {
            // 新用户继续注册
          }
        } else {
          console.warn(res);
        }
      });
    },
    runCountdown(times, callback) {
      if (isNaN(times)) callback("倒计时定时器时间设置错误");
      callback(times);
      let timer = setInterval(() => {
        --times;
        callback(times, timer);
        if (times == 0) clearInterval(timer);
      }, 1000);
    },
    // 切换密码输入框类型
    toggleIptType() {
      this.iptType = this.iptType == "password" ? "text" : "password";
    },
    submit() {
      // 调用form组件的validate方法
      if (this.capthaCheck) return;
      this.$refs.baseForm.validate().then((res) => {
        if (res) {
          let formValues = Object.assign({}, this.baseForm);
          formValues.sex = formValues.sex.value;
          let { year, month, date } = formValues;
          formValues.birthday = `${year.value}${String(month.value).padStart(2, 0)}${String(date.value).padStart(2, 0)}`;
          delete formValues.year;
          delete formValues.month;
          delete formValues.date;
          // 第三方登录
          if (this.ssoCode) formValues.sso_code = this.ssoCode;
          // 分享#会员裂变
          if (utils.getItem("share_uid")) {
            formValues.parentid = utils.getItem("share_uid");
            utils.removeItem("share_uid");
          }
          // 
          if (this.mode == 'connect') {
            this.memberConnect(formValues);
          } else {
            this.memberJoin(formValues);
          }
        }
      }).catch((e) => console.warn(e));
    },
    // 创建账户
    memberJoin(formValues) {
      api[types.USER_REGISTER](formValues).then((res) => {
        if (res.code == 1) {
          utils.removeItem("sso_code");
          let returnUrl = decodeURIComponent(this.$route.query?.returnUrl || "/");
          let isCheckout = returnUrl.indexOf("checkout") != -1;
          this.$store.commit(types.USER_LOGIN, res.data);
          this.$store.dispatch(types.GET_PROFILE);
          this.$store.dispatch(types.CART_GET, () => {
            isCheckout && this.$router.replace({ path: returnUrl });
          });
          this.$store.dispatch(types.FAV_PIDS_LIST);
          this.$toast({ message: "创建成功", iconCls: "success" });
          !isCheckout && this.$router.replace({ path: returnUrl });
        } else {
          switch (res.data.field) {
            case "msg_code":
              this.phonecodeError = true;
              this.phonecodeMsg = res.message;
              this.nameError = false;
              this.nameMsg = "";
              this.capthaCheck = false;
              this.capthaError = "";
              break;
            case "valid_code":
              this.capthaCheck = false;
              this.capthaError = res.message;
              this.nameError = false;
              this.nameMsg = "";
              this.phonecodeError = false;
              this.phonecodeMsg = "";
              break;
            case "name":
              this.nameError = true;
              this.nameMsg = res.message;
              this.phonecodeError = false;
              this.phonecodeMsg = "";
              this.capthaCheck = false;
              this.capthaError = "";
              break;
            default:
              this.error = true;
              this.errMsg = res.message;
              break;
          }
        }
      }).catch((err) => console.warn(err));
    },
    // 关联账户
    memberConnect(formValues) {
      api[types.APPROACH_INFO](formValues).then(res => {
        if (res.code == 1) {
          utils.removeItem("sso_code");
          let returnUrl = decodeURIComponent(this.$route.query?.returnUrl || "/");
          let isCheckout = returnUrl.indexOf("checkout") != -1;
          this.$store.commit(types.USER_LOGIN, res);
          this.$store.dispatch(types.GET_PROFILE);
          this.$store.dispatch(types.CART_GET, () => {
            isCheckout && this.$router.replace({ path: returnUrl });
          });
          this.$store.dispatch(types.FAV_PIDS_LIST);
          this.$toast({ message: "关联成功", iconCls: "success" });
          !isCheckout && this.$router.replace({ path: returnUrl });
        } else {
          switch (res.data.field) {
            case "msg_code":
              this.phonecodeError = true;
              this.phonecodeMsg = res.message;
              this.nameError = false;
              this.nameMsg = "";
              this.capthaCheck = false;
              this.capthaError = "";
              break;
            case "valid_code":
              this.capthaCheck = true;
              this.capthaError = res.message;
              this.nameError = false;
              this.nameMsg = "";
              this.phonecodeError = false;
              this.phonecodeMsg = "";
              break;
            case "name":
              this.nameError = true;
              this.nameMsg = res.message;
              this.phonecodeError = false;
              this.phonecodeMsg = "";
              this.capthaCheck = false;
              this.capthaError = "";
              break;
            default:
              this.phoneError = true;
              this.errMsg = res.message;
              break;
          }
        }
      }).catch(err => console.warn(err));
    }
  },
  computed: {
    isMobile() {
      return utils.isMobile();
    },
    allowedSexes() {
      return [
        { label: "先生", value: 1 },
        { label: "女士", value: 0 },
      ];
    },
    allowedYears() {
      let base = new Date().getFullYear();
      let ret = [];
      for (let i = 0; i < 80; i++) {
        ret.push({ label: `${base - i}年`, value: base - i });
      }
      return ret;
    },
    allowedMonths() {
      let ret = [];
      if (this.baseForm.year) {
        for (let i = 1; i <= 12; i++) {
          ret.push({ label: `${i}月`, value: i });
        }
      }
      return ret;
    },
    allowedDates() {
      let ret = [];
      let { year, month, date } = this.baseForm;
      if (year && month) {
        let days = new Date(year.value, month.value, 0).getDate();
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        if (days < date?.value) this.baseForm.date = null;
        for (let i = 1; i <= days; i++) {
          ret.push({ label: `${i}日`, value: i });
        }
      }
      return ret;
    },
    disableSendSMS() {
      if (this.countdown) return true;
      let { phone, valid_code } = this.baseForm;
      let capthaCheck = this.capthaCheck;
      if (/^1[3456789]\d{9}$/.test(phone) && valid_code && !capthaCheck) {
        return false;
      }
      return true;
    },
    disableSubmit() {
      let { phone, valid_id, valid_code, msg_code, sex, name, year, month, date, password } = this.baseForm;
      if (phone && valid_id && valid_code && msg_code && sex != undefined && name && year && month && date && password && this.userCheck) {
        return false;
      }
      return true;
    }
  },
};
</script>

<style lang="scss" scoped>
.form-control-color {
  background-color: #f5f5f5;
  border-color: #f5f5f5;
  transition: all 0.1s ease-in-out;
  overflow: hidden;
  border-radius: 20px;
  &.c-input-error {
    border: 1px solid #df4c4c;
    background: #ffeaea;
  }
  & /deep/ .multiselect__select {
    z-index: -1;
  }
  & /deep/.multiselect__single {
    background: #f5f5f5;
  }
  & /deep/.multiselect__tags {
    background: #f5f5f5;
  }
}
.logo-wrap {
  padding: 1.25rem 0;
  .icon-link {
    text-decoration: none;
  }
  .icon-logo {
    font-size: 2.375rem;
    color: #000;
  }
}
.privacy-row {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  font-size: 12px;
  color: #5e5e5e;
  line-height: 24px;
  .iconfont {
    margin-right: 10px;
  }
  a {
    margin: 0 4px;
    word-break: keep-all;
    white-space: nowrap;
  }
}
.clickable {
  cursor: pointer;
}
.c-input {
  &.is-invalid {
    border-color: #c53131;
  }
}
.form-item_mn .eye-icon__container {
  top: 70%;
  cursor: pointer;
}
.years {
  width: 48%;
  display: inline-block;
  margin-right: 4%;
}
.months {
  width: 22%;
  display: inline-block;
  margin-right: 4%;
}
.days {
  width: 22%;
  display: inline-block;
}
.c-select {
  &:first-child {
    display: none;
  }
}
.m-account-registration {
  padding: 0 1.125rem;
  .c-sisley-club {
    margin: 2.5rem 0;
  }
  .c-sisley-club__title-container {
    height: auto;
    bottom: 0;
  }
}
.c-sisley-club__title-container {
  width: 100%;
  height: 3.9375rem;
  top: auto;
  bottom: 0.875rem;
  display: flex;
  color: #000;
  justify-content: center;
  align-items: center;
}
.c-sisley-club {
  border: 0.0625rem solid #f5f5f5;
  padding-bottom: 2.5rem;
}
.c-sisley-club__text {
  max-width: 18.75rem;
  padding-bottom: 1.6875rem;
}
.float-center {
  display: block;
  margin-right: auto;
  margin-left: auto;
}
.m-account-registration__column {
  // max-width: 21.375rem;
  margin: 0 auto;
}
.m-account-registration__form {
  padding: 2.5rem 0;
}
.c-sisley-club__images-container {
  position: relative;
  padding: 1.375rem 1.375rem 2.6875rem;
}
.c-sisley-club__image {
  &:first-child {
    text-align: right;
  }
  &:nth-child(2) {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 5.6875rem;
  }
}
.c-account-registration {
  margin: 0 auto;
  color: #000;
}
.c-account-registration /deep/ .form-item_mn .label {
  font-weight: 700;
}
.c-account-registration__description,
.c-account-registration__title {
  padding-bottom: 1.25rem;
}
.c-account-registration__title {
  font-size: 0.875rem;
  color: #282828;
  font-weight: 700;
}
.c-account-registration__description {
  font-size: 0.75rem;
  color: #5e5e5e;
}
form {
  position: relative;
}
.c-input--fullwidth {
  width: 100%;
}
.c-account-registration__msg {
  padding: 1.25rem 0;
  text-align: right;
}
.pic-code {
  cursor: pointer;
}
.c-input-error {
  border: 1px solid #df4c4c;
  background: #ffeaea;
}
.error-msg {
  color: #df4c4c;
  padding: 0.175rem 1rem 0;
}
@media screen and (min-width: 48m) {
  .m-account-registration__column {
    max-width: 26.3125rem;
  }
}

@media screen and (min-width: 64em) {
  .m-account-registration {
    padding: 0;
  }
  .m-account-registration__column {
    max-width: 30.6875rem;
    margin: 0;
  }
  .m-account-registration__form {
    padding: 3.125rem 0;
  }
}
@media screen and (min-width: 75em) {
  .c-account-registration {
    margin: 0;
  }
}
/deep/ .c-account-registration {
  .multiselect__placeholder,
  .multiselect__single {
    white-space: nowrap;
  }
}
</style>